import { useTranslation } from "react-i18next";
import { useColumns } from "./useColumns";
import { useHistoryApi } from "../../../helpers/historyHelpers/api";
import { useNewTable } from "../../../../../components/NTable/hook";
import { useEffect } from "react";
import Drawer from "../../../../../components/Drawer";
import Table from "../../../../../components/NTable";

const HistoryDrawer = ({ open, close, id }) => {
    const { t } = useTranslation();
    const columns = useColumns();

    const { getHistory, data, totalItems, loading } = useHistoryApi();

    const table = useNewTable({
        data,
        totalItems,
        loading,
        columns,
        enableRowSelection: false,
    });

    const { pagination } = table.getState();

    useEffect(() => {
        const controller = new AbortController();

        const params = {
            entity: "budget",
            page: pagination.pageIndex + 1,
            perPage: pagination.pageSize,
        };

        if (id) {
            params.entityId = id;
        }

        getHistory(params, controller);
        return () => controller.abort();
    }, [getHistory, pagination, id]);

    return (
        <Drawer className="settings-history-drawer" title={t("history")} open={open} close={close}>
            <Table table={table} />
        </Drawer>
    );
};

export default HistoryDrawer;
